import {
  AfterContentInit,
  Component,
  ContentChildren,
  Input,
  OnInit,
  QueryList,
  TemplateRef,
} from '@angular/core';
import { IpTabComponent } from '../ip-tab/ip-tab.component';

@Component({
  selector: 'app-ip-tab-panel',
  templateUrl: './ip-tab-panel.component.html',
  styleUrls: ['./ip-tab-panel.component.scss'],
})
export class IpTabPanelComponent implements OnInit, AfterContentInit {
  @ContentChildren(IpTabComponent)
  tabs!: QueryList<IpTabComponent>;

  @Input()
  headerTemplate!: TemplateRef<any>;

  constructor() {}

  get tabsContext() {
    return {
      tabs: this.tabs,
    };
  }

  ngOnInit(): void {}

  ngAfterContentInit(): void {
    const selectedTab = this.tabs.find((tab) => tab.selected);
    if (!selectedTab && this.tabs.first) {
      this.tabs.first.selected = true;
    }
  }

  selectTab(tab: IpTabComponent) {
    this.tabs.forEach((t) => (t.selected = false));
    tab.selected = true;
  }
}
